import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarRail,
  SidebarTrigger,
  useSidebar,
} from '@/components/ui/sidebar';
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { getLocalizedName } from '@/lib/utils';
import { useAuthStore } from '@/features/auth/stores/auth.store';

import { NavMain } from './NavMain';

export function AppSidebar() {
  const { t, i18n } = useTranslation('common');
  const navigate = useNavigate();
  const { state } = useSidebar();
  const user = useAuthStore((state) => state.user);

  const isExpanded = state === 'expanded';

  const handleUserClick = () => {
    if (user?.id) {
      navigate(`/app/users/${user.id}`);
    }
  };

  return (
    <Sidebar collapsible="icon" className="w-[210px]">
      <SidebarContent className="mt-[66px] bg-secondary-bg pb-16 text-white">
        <NavMain />
      </SidebarContent>

      <SidebarFooter className="bg-secondary-bg text-white">
        <div
          className="mb-4 flex cursor-pointer items-center gap-4 hover:opacity-80"
          role="button"
          tabIndex={0}
          onClick={handleUserClick}
          onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleUserClick()}
        >
          <Avatar className="h-7 w-7 bg-white p-1">
            <AvatarImage src="/images/Logo_Andersen.png" alt={user?.name} />
            <AvatarFallback>
              {user?.name?.charAt(0)?.toUpperCase() || 'U'}
            </AvatarFallback>
          </Avatar>
          {isExpanded && (
            <div className="flex flex-col items-start">
              <span className="text-sm font-medium">{user?.name}</span>
              <span className="text-xs text-gray-400">{getLocalizedName(user?.role, i18n.language)}</span>
            </div>
          )}
        </div>

        <div className="mb-4 flex items-center gap-4">
          <SidebarTrigger className="rounded-full bg-white text-button" />
          {isExpanded && <span className="text-sm">{t('actions.close')}</span>}
        </div>
      </SidebarFooter>

      <SidebarRail />
    </Sidebar>
  );
}
